import React from 'react'

export default props => (
    <div className="tab-content">
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/common/tab/tabsContent.jsx